import { CanActivateFn } from '@angular/router';
import { AuthService } from './auth.service';
import { inject } from '@angular/core';
import { NavController } from '@ionic/angular';
import { PlatformService } from '../platform/platform.service';
import { ReturnUrlService } from '../return-url/return-url.service';

export const authGuard: CanActivateFn = (route, state) => {
  const authService = inject(AuthService);
  const navController = inject(NavController);
  const platformService = inject(PlatformService);
  const returnUrlService = inject(ReturnUrlService);
  const isCordova = platformService.isCordova();

  if (!authService.isAuthenticatedSignal()) {
    returnUrlService.stash(state.url);

    // No signOutParam: it would make AuthPage skip verifyUserCredentials() and force a
    // full external sign-in, even on a cold start with a valid stored token.
    const path = isCordova ? '/sign-in' : '/auth';
    navController.navigateRoot([path]);
    return false;
  }

  return true;
};
